import { useFormik } from 'formik';
import { Hooks } from 'providers';
import { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from 'yup';

import { Organization } from 'providers/Organization';
import { useOuterClick } from 'providers/OutsideClick';

import {
  HIT_EMPLOYEE_CHART,
  HIT_UPDATE_NODE_EMPLOYEE,
} from 'redux/actions/organization';

function ModalForm(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    pid__,
    modalAddEmployee: modal,
    setModalAddEmployee: setModal,
    setPid__,
    setEmployeeModal,
    employeeModal,
  } = useContext(Organization);
  const { setModal: setModal__, modal: modal__ } = useContext(Hooks);
  const {
    listStructure, list_employee,
  } = useSelector(
    (state) => ({
      listStructure: state.organization.structure,
      list_employee: state.organization.employee_chart.filter(
        (val, i) => val.employee_id === pid__,
      )[0],
    }),
  );

  const MappingListStructure = useMemo(() => listStructure?.map((val) => ({
    value: val.organization_id,
    label: val.name,
  })), [listStructure]);

  const innerRef = useOuterClick((e) => {
    if (e.srcElement.id === 'updateNodesEmployee') {
      setEmployeeModal(false);
    }
  });

  const formik = useFormik({
    initialValues: {
      nik: '',
      nama: '',
      organization_id: '',
      employee_id: '',
    },
    validationSchema: Yup.object().shape({
      // employee_id: Yup.string()
      //   .typeError("Must be string")
      //   .required("Job Level ID cannot empty"),
      nama: Yup.string()
        .typeError('Must be string')
        .required('Job Level ID cannot empty'),
      // organization_id: Yup.string()
      //   .typeError("Must be string")
      //   .required("Job Level ID cannot empty"),
    }),
    onSubmit: async (values, { resetForm }) => {
      await dispatch({
        type: HIT_UPDATE_NODE_EMPLOYEE,
        payload: values,
      });
      setModal(false);
      setModal__(false);
      setEmployeeModal(false);
      setTimeout(() => {
        dispatch({
          type: HIT_EMPLOYEE_CHART,
          payload: {
            // board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
            board_id: localStorage.getItem('board_id'),
            organization_id: '008689ae-a3ad-11e9-8f66-b42e992b9a51',
          },
        });
      }, 100);
    },
  });
  useEffect(() => {
    // if (job_.length === 0) {
    //   dispatch({
    //     type: HIT_LIST_JOB,
    //     payload: {
    //       board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
    //     },
    //   });
    // }
    // dispatch({
    //   type: HIT_LIST_ORGANIZATION,
    //   payload: {
    //     board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
    //   },
    // });
  }, []);
  useEffect(() => {
    formik.setValues({
      ...list_employee,
      org_show: {
        label: list_employee?.position,
        value: list_employee?.organization_id,
      },
    });
  }, [pid__]);

  return (
    <div
      id="updateNodesEmployee"
      className={`modal fade rModal ${employeeModal && 'show'}`}
      style={{
        display: employeeModal ? 'block !important' : 'none !important',
        width: 'fit-content',
        height: 'fit-content',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div
        id="updateNodesEmployee"
        className="org-chart org-chart w-100 h-100 d-flex my-auto mx-auto"
      >
        <div ref={innerRef} className="org-chart_wrap my-auto mx-auto">
          <form action="" onSubmit={() => formik.handleSubmit()}>
            <h3>{props.title}</h3>
            <label>Name</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="nama"
              value={formik.values.nama}
              placeholder="Enter your name"
              onChange={formik.handleChange}
            />
            {formik.touched.namnamae && formik.errors.nama ? (
              <>
                <span className="error">{formik.errors.nama}</span>
                <br />
              </>
            ) : null}
            <label>Nik</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="nik"
              id="nik"
              value={formik.values.nik}
              onChange={formik.handleChange}
              placeholder="Enter your NIK"
            />
            {formik.touched.tag && formik.errors.tag ? (
              <>
                <span className="error">{formik.errors.tag}</span>
                <br />
              </>
            ) : null}
            <label>Organization</label>
            <Select
              options={MappingListStructure}
              type="text"
              name="organization_id"
              onChange={(e) => {
                formik.setValues({
                  ...formik.values,
                  organization_id: e.value,
                  org_show: {
                    label: e.label,
                    value: e.value,
                  },
                });
              }}
              value={formik.values.org_show}
              placeholder="Select Parent"
            />
            {formik.touched.organization_id && formik.errors.organization_id ? (
              <>
                <span className="error">{formik.errors.organization_id}</span>
                <br />
              </>
            ) : null}
            <div className="btn-submit d-flex justify-content-center align-items-center float-right mt-4">
              <button
                className="add"
                type="button"
                onClick={(e) => {
                  formik.handleSubmit(e);
                }}
              >
                {t('board.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalForm;
